import { isEqual } from 'lodash';
import * as types from './types';
import { options } from '../users/';

const INITIAL_STATE = {
  data: {},
  lastFetch: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CURRENT_USER_RECEIVED: {
      const currentUser = options.transform(action.payload.currentUser);
      const data = isEqual(currentUser, state.data) ? state.data : currentUser;

      return { data, lastFetch: Date.now() };
    }
    default: {
      return state;
    }
  }
};
